var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_1192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_245_1192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0642 7.26917C10.4867 6.84667 11.1692 6.84667 11.5917 7.26917L16.5642 12.2417C16.9867 12.6642 16.9867 13.3467 16.5642 13.7692L11.5917 18.7417C11.1692 19.1642 10.4867 19.1642 10.0642 18.7417C9.64173 18.3192 9.64173 17.6367 10.0642 17.2142L14.2676 13L10.0642 8.79667C9.64173 8.37417 9.65256 7.68084 10.0642 7.26917Z",
    fill: "#323232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_1192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_245_1192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "matrix(-1 0 0 1 26 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.7af1074406b088465bcf2f8c8ceb2256.svg";
export { ForwardRef as ReactComponent };